<template>
  <div>
    <div class="mains" v-if="loading" v-loading="loading" element-loading-spinner="el-icon-loading"></div>
    <div v-else>
      <div class="man-title">
        <span>待下载列表</span>
      </div>
      <div class="table-list">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="fileName" label="文件名称">
            <template slot-scope="scope">
              <span>{{ scope.row.fileName?scope.row.fileName:'-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="fileType" label="文件类型">
            <template slot-scope="scope">
              <span v-if="scope.row.fileType=='operationRecordExcel'">巡检历史记录</span>
              <span v-else-if="scope.row.fileType=='operationAnalysisReportPdf'">巡检分析报表</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="时间段">
            <template slot-scope="scope">
              <span>{{ scope.row.startTime ? dayjs(scope.row.startTime).format('YYYY-MM-DD'):'' }}</span>
              <span>{{ scope.row.startTime ? ' — ':'-' }}</span>
              <span>{{ scope.row.endTime ? dayjs(scope.row.endTime).format('YYYY-MM-DD'):'' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="staffName" label="人员"></el-table-column>
          <el-table-column prop="downStatus" label="下载状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.downStatus == 1" size="small" type="success">已下载</el-tag>
              <el-tag v-else size="small" type="warning">未下载</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="导出时间">
            <template slot-scope="scope">
              {{ scope.row.createTime ? dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss'):'' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-dropdown placement="bottom-start" trigger="click">
                <span @click.stop="">
                  <span class="el-dropdown-link">
                    操作<i class="el-icon-arrow-down"></i>
                  </span>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><div @click="download(scope.row)">下载</div></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <page v-if="total!==0" :size="size" :page="page" :total="total" v-on:sizeChange="sizeChange" v-on:pageChange="pageChange"></page>
      </div>
    </div>
  </div>
</template>

<script>
import page from '@/components/page.vue'
import dayjs from 'dayjs';
export default {
  components: {
    page
  },
  data() {
    return {
      loading: false,
      size: 50,
      page: 1,
      total: 0,
      formInline: {},
      tableData: [],
      isChangeOpen: 0,
      isDetailOpen: 0,
      isEditOpen: 0,
      sheshi: [],
      bumen: [],
      leixin: [],
      yuangong: [],
      detailRow: {},
      editRow: {},
      roleId: 0
    };
  },
  methods: {
    dayjs,
    download(row) {
      window.open(row.fileUrl);
      this.$ajax.post('changeDownloadStatus',{},{},row.fileId).then(res => {
        this.loadListData()
        this.$message.success('下载成功')
      })
    },
    loadListData() {
      this.loading = true
      this.$ajax.post('fileBoxQuery',{
        pageNum: this.page,
        pageSize: this.size
      }).then(res => {
        this.tableData = res.data
        this.total = res.total
        this.loading = false
      }).catch(err=>{
        this.loading = false
      })
    },
    pageChange(val) {
      this.page = val
      sessionStorage.setItem('currentPage', val)
      this.loadListData()
    },
    sizeChange(val) {
      this.size = val
      sessionStorage.setItem('currentSize', val)
      this.loadListData()
    },
    getLastPage() {
      this.page = Number(sessionStorage.getItem('currentPage')) || 1
    },
    getSize() {
      this.size = Number(sessionStorage.getItem('currentSize')) || 50
    },
  },
  mounted() {
    this.getLastPage()
    this.getSize()
    this.loadListData()
    this.roleId = sessionStorage.getItem('r')
  }
};
</script>

<style lang="less" scoped>
.mains {
  padding: 400px 0;
  height: 100%;
}
/deep/.el-loading-spinner .el-icon-loading{
  font-size: 50px;
}
.btn {
  float: right;
}
.search {
  padding: 0 10px;
}
</style>